import { render } from "./CreditoView.vue?vue&type=template&id=2a48930e&scoped=true"
import script from "./CreditoView.vue?vue&type=script&lang=js"
export * from "./CreditoView.vue?vue&type=script&lang=js"

import "./CreditoView.vue?vue&type=style&index=0&id=2a48930e&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a48930e"]])

export default __exports__